import React from 'react';
import Events from './Events';
import { useLocalization } from '../localization';

const OldEvents: React.FC = () => {
  const { copy } = useLocalization();
  return <Events order="desc" past={true} title={copy.events.pastTitle} />;
};

export default OldEvents;
